/**
 * @author       tae@zumper.com (Tae Yoon)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Detail monetized similar listings meta reducer
 */

import { falseReducer, nullReducer, payloadKeyReducer, trueReducer } from '@zcode/reducers'
import type { MonetizedSimilarListings } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { type ExtractActions, type Values, handleActions } from 'redux-actions'
import type { clearEntity } from '../../entity/actions/index'
import { CLEAR_ENTITY } from '../../entity/constants/index'
import type * as actions from '../actions/index'
import {
  CLEAR_MONETIZED_SIMILAR_LISTINGS,
  DONE_FETCHING_MONETIZED_SIMILAR_LISTINGS,
  ERROR_FETCHING_MONETIZED_SIMILAR_LISTINGS,
  RECEIVE_MONETIZED_SIMILAR_LISTINGS,
  START_FETCHING_MONETIZED_SIMILAR_LISTINGS,
} from '../constants/index'

export type Actions = ExtractActions<Values<typeof actions> | typeof clearEntity>
type Meta = MonetizedSimilarListings['meta']

export const metaReducer = combineReducers<Meta, Actions>({
  error: handleActions<Meta['error'], Actions>(
    {
      [ERROR_FETCHING_MONETIZED_SIMILAR_LISTINGS]: payloadKeyReducer('error'),
      [CLEAR_ENTITY]: nullReducer,
      [CLEAR_MONETIZED_SIMILAR_LISTINGS]: nullReducer,
      [START_FETCHING_MONETIZED_SIMILAR_LISTINGS]: nullReducer,
    },
    null
  ),
  fetching: handleActions<Meta['fetching'], Actions>(
    {
      [START_FETCHING_MONETIZED_SIMILAR_LISTINGS]: trueReducer,
      [CLEAR_ENTITY]: falseReducer,
      [CLEAR_MONETIZED_SIMILAR_LISTINGS]: falseReducer,
      [DONE_FETCHING_MONETIZED_SIMILAR_LISTINGS]: falseReducer,
    },
    false
  ),
  fetchingKey: handleActions<Meta['fetchingKey'], Actions>(
    {
      [START_FETCHING_MONETIZED_SIMILAR_LISTINGS]: payloadKeyReducer('key'),
      [CLEAR_ENTITY]: nullReducer,
      [CLEAR_MONETIZED_SIMILAR_LISTINGS]: nullReducer,
      [DONE_FETCHING_MONETIZED_SIMILAR_LISTINGS]: nullReducer,
    },
    null
  ),
  currentKey: handleActions<Meta['currentKey'], Actions>(
    {
      [CLEAR_MONETIZED_SIMILAR_LISTINGS]: nullReducer,
      [CLEAR_ENTITY]: nullReducer,
      [RECEIVE_MONETIZED_SIMILAR_LISTINGS]: payloadKeyReducer('key'),
    },
    null
  ),
})
